import React from 'react';
import PropTypes from 'prop-types';

const TabRow = ({ id, name, isHidden, deleteView, updateView, updateVisibility }) => {
    const handleDeleteClick = () => deleteView(id);
    const handleEditClick = () => updateView(id);
    const handleHideClick = () => updateVisibility(id, true);
    const handleUnhideClick = () => updateVisibility(id, false);

    return (
        <div key={`tap_${id}`} className="manage-taps-row">
            <div className="title">{name}</div>
            <div onClick={handleEditClick} className="edit">
                edit
            </div>
            <div onClick={handleDeleteClick} className="delete">
                delete
            </div>
            {isHidden ? (
                <div onClick={handleUnhideClick} className="edit">
                    unhide
                </div>
            ) : (
                <div onClick={handleHideClick} className="edit">
                    hide
                </div>
            )}
        </div>
    );
};

TabRow.propTypes = {
    id: PropTypes.number,
    name: PropTypes.string,
    isHidden: PropTypes.bool,

    updateVisibility: PropTypes.func.isRequired,
    deleteView: PropTypes.func.isRequired,
    updateView: PropTypes.func.isRequired,
};

export default React.memo(TabRow);



// WEBPACK FOOTER //
// ./source/screens/manageTabs/tabRow.js